module.exports = "<pre><code class=\"hljs scss\"><span class=hljs-selector-id>#root</span> {\n  <span class=hljs-attribute>height</span>: <span class=hljs-number>100%</span>;\n  <span class=hljs-attribute>left</span>: <span class=hljs-number>0</span>;\n  <span class=hljs-attribute>overflow</span>: auto;\n  <span class=hljs-attribute>position</span>: absolute;\n  <span class=hljs-attribute>top</span>: <span class=hljs-number>0</span>;\n  <span class=hljs-attribute>width</span>: <span class=hljs-number>100%</span>;\n}\n</code></pre> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/example-rw-02.md
 ** module id = 112
 ** module chunks = 1
 **/